import React, { useState } from "react";

const tooltipConfig = {
  top: {
    classes: "-top-6 left-1/2 transform -translate-x-1/2",
    arrow: "top-full left-1/2 transform -translate-x-1/2 border-l-4 border-r-4 border-t-4 border-transparent border-t-gray-900"
  },
  bottom: {
    classes: "top-full left-1/2 transform -translate-x-1/2 mt-1",
    arrow: "bottom-full left-1/2 transform -translate-x-1/2 border-l-4 border-r-4 border-b-4 border-transparent border-b-gray-900"
  },
  left: {
    classes: "right-full top-1/2 transform -translate-y-1/2 mr-1",
    arrow: "left-full top-1/2 transform -translate-y-1/2 border-t-4 border-b-4 border-l-4 border-transparent border-l-gray-900"
  },
  right: {
    classes: "left-full top-1/2 transform -translate-y-1/2 ml-1",
    arrow: "right-full top-1/2 transform -translate-y-1/2 border-t-4 border-b-4 border-r-4 border-transparent border-r-gray-900"
  }
};

function Tooltip({ children, content, position = "top", className = "" }) {
  const [showTooltip, setShowTooltip] = useState(false);
  
  const config = tooltipConfig[position] || tooltipConfig.top;
  const baseClasses = "absolute z-10 px-2 py-1 text-xs text-white bg-gray-900 rounded shadow-md whitespace-nowrap";

  return (
    <div 
      className={`relative inline-block ${className}`}
      onMouseEnter={() => setShowTooltip(true)}
      onMouseLeave={() => setShowTooltip(false)}
    >
      {children}
      {showTooltip && (
        <div className={`${baseClasses} ${config.classes}`}>
          {content}
          <div className={`absolute w-0 h-0 ${config.arrow}`}></div>
        </div>
      )}
    </div>
  );
}

export default Tooltip;
